// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Forgot Password page — shares the \`auth-page\` / \`auth-form\`
   design system defined in  /pages/Login/styles.scss.
   If the user lands directly on /forgot-password, Login's
   styles.scss hasn't loaded yet, so we include the full shared
   design tokens here too to guarantee coverage.
   ============================================================ */
.auth-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  font-family: "Inter", sans-serif;
  background: #f8fafc;
}
.auth-page--standalone {
  justify-content: center;
  align-items: center;
  background: radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%), radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.1), transparent 60%), #f8fafc;
  padding: 32px 16px;
}
.auth-page__logo-mark--small {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #eff6ff;
  border: 1px solid rgba(0, 65, 149, 0.15);
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-page__logo-accent {
  font-size: 20px;
  font-weight: 800;
  color: #004195;
  letter-spacing: -0.5px;
}
.auth-page__card {
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border-radius: 18px;
  padding: 44px 40px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 16px 48px -16px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
}
.auth-page__card--wide {
  max-width: 480px;
}
.auth-page__header {
  margin-bottom: 32px;
  text-align: center;
}
.auth-page__title {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 8px;
  color: #0f172a;
  letter-spacing: -0.4px;
}
.auth-page__subtitle {
  font-size: 15px;
  line-height: 1.55;
  margin: 0;
  color: #64748b;
  font-weight: 400;
}
.auth-page__footer {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  text-align: center;
}
.auth-page__footer-muted {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.auth-form__item {
  margin-bottom: 20px;
}
.auth-form__item .ant-form-item-label > label {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: -0.1px;
}
.auth-form__item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before,
.auth-form__item .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: none !important;
}
.auth-form__input .ant-input,
.auth-form__input .ant-input-affix-wrapper {
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  padding: 0 14px;
  font-size: 15px;
  color: #0f172a;
  transition: all 180ms ease;
  box-shadow: none;
}
.auth-form__input .ant-input::placeholder,
.auth-form__input .ant-input-affix-wrapper::placeholder {
  color: #94a3b8;
  font-weight: 400;
}
.auth-form__input .ant-input:hover,
.auth-form__input .ant-input-affix-wrapper:hover {
  border-color: #075dc5;
}
.auth-form__input .ant-input:focus, .auth-form__input .ant-input.ant-input-focused, .auth-form__input .ant-input.ant-input-affix-wrapper-focused,
.auth-form__input .ant-input-affix-wrapper:focus,
.auth-form__input .ant-input-affix-wrapper.ant-input-focused,
.auth-form__input .ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
  border-color: #004195;
  box-shadow: 0 0 0 4px rgba(0, 65, 149, 0.1);
}
.auth-form__input .ant-input-prefix {
  margin-right: 10px;
}
.auth-form__icon {
  color: #64748b;
}
.auth-form__submit-row {
  margin-top: 8px;
}
.auth-form__submit-btn {
  width: 100% !important;
  height: 48px !important;
  font-size: 16px !important;
  padding: 0 28px !important;
}
.auth-form .ant-form-item-has-error .ant-input,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper {
  border-color: #dc2626 !important;
}
.auth-form .ant-form-item-has-error .ant-input:focus, .auth-form .ant-form-item-has-error .ant-input.ant-input-focused, .auth-form .ant-form-item-has-error .ant-input.ant-input-affix-wrapper-focused,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper:focus,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper.ant-input-focused,
.auth-form .ant-form-item-has-error .ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
  box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.1) !important;
}
.auth-form .ant-form-item-explain-error {
  font-size: 13px;
  color: #dc2626;
  margin-top: 6px;
}

.auth-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin-bottom: 28px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  transition: color 160ms ease, transform 160ms ease;
}
.auth-back-link:hover {
  color: #004195;
  transform: translateX(-2px);
}
.auth-back-link:focus-visible {
  outline: 2px solid #075dc5;
  outline-offset: 4px;
  border-radius: 4px;
}

.invert-fill-btn:disabled {
  cursor: not-allowed !important;
  opacity: 0.72 !important;
  transform: none !important;
  box-shadow: none !important;
}

@media (max-width: 960px) {
  .auth-page--standalone {
    padding: 20px 14px 32px;
    align-items: flex-start;
  }
  .auth-page__card {
    padding: 32px 24px;
    border-radius: 14px;
  }
  .auth-page__title {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;iEAAA;AAkBA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,mBARiB;AADnB;AAWE;EACE,uBAAA;EACA,mBAAA;EACA,uLACE;EAGF,kBAAA;AAZJ;AAgBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBA9Ba;EA+Bb,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdN;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,cA5Ce;EA6Cf,sBAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,gBAAA;EACA,mBA3Ce;EA4Cf,mBAAA;EACA,kBAAA;EACA,sFACE;EAEF,yBAAA;AAnBJ;AAqBI;EACE,gBAAA;AAnBN;AAuBE;EACE,mBAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cArEe;EAsEf,sBAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cA5Ee;EA6Ef,gBAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,cAzFe;EA0Ff,gBAAA;AAzBJ;;AA8BE;EACE,mBAAA;AA3BJ;AA6BI;EACE,eAAA;EACA,gBAAA;EACA,cAtGa;EAuGb,kBAAA;EACA,sBAAA;AA3BN;AA8BI;;EAIE,wBAAA;AA9BN;AAmCI;;EAEE,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAtHa;EAuHb,eAAA;EACA,eAAA;EACA,cA5Ha;EA6Hb,0BAAA;EACA,gBAAA;AAjCN;AAmCM;;EACE,cAAA;EACA,gBAAA;AAhCR;AAmCM;;EACE,qBA1IW;AA0GnB;AAmCM;;;;EAGE,qBAjJW;EAkJX,2CAAA;AAhCR;AAoCI;EACE,kBAAA;AAlCN;AAsCE;EACE,cAtJe;AAkHnB;AAuCE;EACE,eAAA;AArCJ;AAwCE;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;AAtCJ;AA0CI;;EAEE,gCAAA;AAxCN;AAyCM;;;;EAGE,uDAAA;AAtCR;AA2CE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAzCJ;;AA6CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAhMiB;EAiMjB,eAAA;EACA,gBAAA;EACA,kDAAA;AA1CF;AA4CE;EACE,cA5Me;EA6Mf,2BAAA;AA1CJ;AA6CE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AA3CJ;;AA+CA;EACE,8BAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;AA5CF;;AA+CA;EAEI;IACE,uBAAA;IACA,uBAAA;EA7CJ;EAgDA;IACE,kBAAA;IACA,mBAAA;EA9CF;EAgDA;IACE,eAAA;EA9CF;AACF","sourcesContent":["/* ============================================================\n   Forgot Password page — shares the `auth-page` / `auth-form`\n   design system defined in  /pages/Login/styles.scss.\n   If the user lands directly on /forgot-password, Login's\n   styles.scss hasn't loaded yet, so we include the full shared\n   design tokens here too to guarantee coverage.\n   ============================================================ */\n\n$auth-navy:        #004195;\n$auth-navy-alt:    #075dc5;\n$auth-navy-soft:   #eff6ff;\n$auth-border:      #e2e8f0;\n$auth-border-2:    #cbd5e1;\n$auth-text:        #0f172a;\n$auth-text-muted:  #64748b;\n$auth-bg:          #f8fafc;\n$auth-white:       #ffffff;\n\n.auth-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  font-family: 'Inter', sans-serif;\n  background: $auth-bg;\n\n  &--standalone {\n    justify-content: center;\n    align-items: center;\n    background:\n      radial-gradient(1000px 600px at 20% 0%, rgba(7, 93, 197, 0.12), transparent 60%),\n      radial-gradient(800px 500px at 80% 100%, rgba(0, 65, 149, 0.10), transparent 60%),\n      $auth-bg;\n    padding: 32px 16px;\n  }\n\n  &__logo-mark {\n    &--small {\n      width: 48px;\n      height: 48px;\n      border-radius: 12px;\n      background: $auth-navy-soft;\n      border: 1px solid rgba(0, 65, 149, 0.15);\n      margin: 0 auto 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  &__logo-accent {\n    font-size: 20px;\n    font-weight: 800;\n    color: $auth-navy;\n    letter-spacing: -0.5px;\n  }\n\n  &__card {\n    width: 100%;\n    max-width: 480px;\n    background: $auth-white;\n    border-radius: 18px;\n    padding: 44px 40px;\n    box-shadow:\n      0 1px 2px rgba(15, 23, 42, 0.04),\n      0 16px 48px -16px rgba(15, 23, 42, 0.12);\n    border: 1px solid $auth-border;\n\n    &--wide {\n      max-width: 480px;\n    }\n  }\n\n  &__header {\n    margin-bottom: 32px;\n    text-align: center;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1.2;\n    margin: 0 0 8px;\n    color: $auth-text;\n    letter-spacing: -0.4px;\n  }\n\n  &__subtitle {\n    font-size: 15px;\n    line-height: 1.55;\n    margin: 0;\n    color: $auth-text-muted;\n    font-weight: 400;\n  }\n\n  &__footer {\n    margin-top: 28px;\n    padding-top: 20px;\n    border-top: 1px solid $auth-border;\n    text-align: center;\n  }\n\n  &__footer-muted {\n    font-size: 13px;\n    color: $auth-text-muted;\n    line-height: 1.5;\n  }\n}\n\n.auth-form {\n  &__item {\n    margin-bottom: 20px;\n\n    .ant-form-item-label > label {\n      font-size: 14px;\n      font-weight: 600;\n      color: $auth-text;\n      margin-bottom: 8px;\n      letter-spacing: -0.1px;\n    }\n\n    .ant-form-item-label >\n      label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before,\n    .ant-form-item-label >\n      label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n      display: none !important;\n    }\n  }\n\n  &__input {\n    .ant-input,\n    .ant-input-affix-wrapper {\n      height: 40px;\n      border-radius: 8px;\n      border: 1.5px solid $auth-border-2;\n      background: $auth-white;\n      padding: 0 14px;\n      font-size: 15px;\n      color: $auth-text;\n      transition: all 180ms ease;\n      box-shadow: none;\n\n      &::placeholder {\n        color: #94a3b8;\n        font-weight: 400;\n      }\n\n      &:hover {\n        border-color: $auth-navy-alt;\n      }\n\n      &:focus,\n      &.ant-input-focused,\n      &.ant-input-affix-wrapper-focused {\n        border-color: $auth-navy;\n        box-shadow: 0 0 0 4px rgba(0, 65, 149, 0.10);\n      }\n    }\n\n    .ant-input-prefix {\n      margin-right: 10px;\n    }\n  }\n\n  &__icon {\n    color: $auth-text-muted;\n  }\n\n  &__submit-row {\n    margin-top: 8px;\n  }\n\n  &__submit-btn {\n    width: 100% !important;\n    height: 48px !important;\n    font-size: 16px !important;\n    padding: 0 28px !important;\n  }\n\n  .ant-form-item-has-error {\n    .ant-input,\n    .ant-input-affix-wrapper {\n      border-color: #dc2626 !important;\n      &:focus,\n      &.ant-input-focused,\n      &.ant-input-affix-wrapper-focused {\n        box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.10) !important;\n      }\n    }\n  }\n\n  .ant-form-item-explain-error {\n    font-size: 13px;\n    color: #dc2626;\n    margin-top: 6px;\n  }\n}\n\n.auth-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  margin-bottom: 28px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: $auth-text-muted;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 160ms ease, transform 160ms ease;\n\n  &:hover {\n    color: $auth-navy;\n    transform: translateX(-2px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid $auth-navy-alt;\n    outline-offset: 4px;\n    border-radius: 4px;\n  }\n}\n\n.invert-fill-btn:disabled {\n  cursor: not-allowed !important;\n  opacity: 0.72 !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 960px) {\n  .auth-page {\n    &--standalone {\n      padding: 20px 14px 32px;\n      align-items: flex-start;\n    }\n  }\n  .auth-page__card {\n    padding: 32px 24px;\n    border-radius: 14px;\n  }\n  .auth-page__title {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
